// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Section Layout === */
.why-choose {
  background-color: #ffffff;
  padding: 80px 20px;
  text-align: center;
}

.why-choose-container {
  max-width: 1100px;
  margin: 0 auto;
}

/* === Heading & Intro === */
.why-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #025d3c;
  margin-bottom: 10px;
}

.why-intro {
  font-size: 1.1rem;
  color: #333;
  max-width: 700px;
  margin: 0 auto 50px;
  line-height: 1.6;
}

/* === Features Grid === */
.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  text-align: left;
}

/* === Feature Box === */
.feature-box {
  background: #f8f9f8;
  padding: 30px 25px;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.feature-box:hover {
  transform: translateY(-6px);
  background-color: #f0fff6;
}

.feature-icon {
  width: 40px;
  height: 40px;
  margin-bottom: 15px;
}

.feature-box h4 {
  font-size: 1.2rem;
  color: #025d3c;
  font-weight: 600;
  margin-bottom: 10px;
}

.feature-box p {
  font-size: 0.95rem;
  color: #444;
  line-height: 1.6;
}

/* === Responsive === */
@media (max-width: 768px) {
  .why-title {
    font-size: 2rem;
  }

  .why-intro {
    font-size: 1rem;
  }

  .feature-box {
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AboutUs/WhyChooseUs.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* === Section Layout === */\n.why-choose {\n  background-color: #ffffff;\n  padding: 80px 20px;\n  text-align: center;\n}\n\n.why-choose-container {\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n/* === Heading & Intro === */\n.why-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #025d3c;\n  margin-bottom: 10px;\n}\n\n.why-intro {\n  font-size: 1.1rem;\n  color: #333;\n  max-width: 700px;\n  margin: 0 auto 50px;\n  line-height: 1.6;\n}\n\n/* === Features Grid === */\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 30px;\n  text-align: left;\n}\n\n/* === Feature Box === */\n.feature-box {\n  background: #f8f9f8;\n  padding: 30px 25px;\n  border-radius: 12px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n.feature-box:hover {\n  transform: translateY(-6px);\n  background-color: #f0fff6;\n}\n\n.feature-icon {\n  width: 40px;\n  height: 40px;\n  margin-bottom: 15px;\n}\n\n.feature-box h4 {\n  font-size: 1.2rem;\n  color: #025d3c;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.feature-box p {\n  font-size: 0.95rem;\n  color: #444;\n  line-height: 1.6;\n}\n\n/* === Responsive === */\n@media (max-width: 768px) {\n  .why-title {\n    font-size: 2rem;\n  }\n\n  .why-intro {\n    font-size: 1rem;\n  }\n\n  .feature-box {\n    padding: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
